/**
 * crypto.randomUUID 는 secure context(https 또는 localhost)에서만 동작.
 * HTTP LAN(IP 주소 접속) 환경 호환을 위한 폴백 UUID 생성기.
 */
export function genId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    try {
      return crypto.randomUUID()
    } catch {
      // secure context 아닌 상황 → 폴백
    }
  }
  // RFC4122 v4 와 유사한 포맷 (충돌 확률 충분히 낮음, 비보안용)
  const rand = (n: number) =>
    Array.from({ length: n }, () => Math.floor(Math.random() * 16).toString(16)).join('')
  return `${rand(8)}-${rand(4)}-4${rand(3)}-${(8 + Math.floor(Math.random() * 4)).toString(16)}${rand(3)}-${rand(12)}`
}
